import type { FC } from 'react';

/* ---- #cards ---- */
const CARDS = [
  {
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20scene%20of%20a%20fantasy%20adventure%20group%20traveling%20through%20a%20magical%20forest%20with%20glowing%20mushrooms%2C%20warm%20sunlight%2C%20soft%20atmospheric%20lighting%2C%20adventure%20vibe&width=600&height=400&seq=card-01-sakura&orientation=landscape',
    tag: '热血冒险',
    title: '剑风传说 第3季',
    desc: '王道热血冒险巨作，每周更新不容错过',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20peaceful%20slice-of-life%20scene%20of%20a%20high%20school%20rooftop%20at%20sunset%2C%20two%20students%20chatting%2C%20warm%20golden%20hour%20light%2C%20romantic%20atmosphere&width=600&height=400&seq=card-02-sakura&orientation=landscape',
    tag: '恋爱日常',
    title: '青春物语',
    desc: '温暖治愈校园日常，甜到心底的恋爱故事',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20dark%20mysterious%20detective%20office%20filled%20with%20case%20files%20and%20clues%2C%20moody%20lighting%20with%20lamps%2C%20noir%20atmosphere%2C%20intriguing%20composition&width=600&height=400&seq=card-03-sakura&orientation=landscape',
    tag: '悬疑推理',
    title: '暗夜侦探录',
    desc: '烧脑推理番，每一集都让你意想不到',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20beautiful%20otherworld%20with%20floating%20islands%20and%20waterfalls%20cascading%20into%20clouds%2C%20vibrant%20fantasy%20colors%2C%20a%20lonely%20figure%20gazing%20at%20the%20horizon&width=600&height=400&seq=card-04-sakura&orientation=landscape',
    tag: '奇幻异世界',
    title: '异世界漫步指南',
    desc: '最全异世界转生番合集，一次看过瘾',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20Chinese%20martial%20arts%20scene%20with%20a%20warrior%20practicing%20under%20cherry%20blossom%20trees%2C%20traditional%20Chinese%20architecture%20background%2C%20ink%20wash%20painting%20aesthetic&width=600&height=400&seq=card-05-sakura&orientation=landscape',
    tag: '国漫精选',
    title: '国漫之光',
    desc: '国产动画精品力作，文化自信的新时代',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20emotional%20healing%20scene%20with%20soft%20pastel%20colors%2C%20a%20small%20creature%20comforting%20someone%20under%20a%20tree%2C%20gentle%20warm%20lighting%2C%20therapeutic%20atmosphere&width=600&height=400&seq=card-06-sakura&orientation=landscape',
    tag: '治愈系',
    title: '心灵疗愈所',
    desc: '温暖人心的治愈动画，抚平你的疲惫',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20epic%20theatrical%20movie%20poster%20aesthetic%20with%20grand%20orchestral%20hall%20transformed%20into%20a%20magical%20realm%2C%20golden%20spotlight%2C%20cinematic%20composition&width=600&height=400&seq=card-07-sakura&orientation=landscape',
    tag: '剧场版',
    title: '大银幕精选',
    desc: '不可错过的动画电影，视听盛宴等你来',
  },
];

export const CardsSection: FC = () => (
  <section id="cards" className="py-14 md:py-20 bg-background-100">
    <div className="section-container">
      <div className="text-center mb-10">
        <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-3">
          精选推荐
        </span>
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
          编辑精选动漫
        </h2>
        <p className="mt-2 text-sm text-foreground-500">精心挑选的高质量动漫作品推荐</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {CARDS.slice(0, 4).map((card, i) => (
          <div key={i} className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/60">
            <div className="relative aspect-[3/2] overflow-hidden">
              <img
                src={card.image}
                alt={card.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <span className="absolute top-3 left-3 px-2 py-0.5 rounded-full bg-primary-500/85 text-white text-[10px] font-semibold">
                {card.tag}
              </span>
            </div>
            <div className="p-4">
              <h3 className="text-sm font-bold text-foreground-900 mb-1">{card.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{card.desc}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 mt-5">
        {CARDS.slice(4, 7).map((card, i) => (
          <div key={i} className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/60">
            <div className="relative aspect-[3/2] overflow-hidden">
              <img
                src={card.image}
                alt={card.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <span className="absolute top-3 left-3 px-2 py-0.5 rounded-full bg-accent-500/85 text-white text-[10px] font-semibold">
                {card.tag}
              </span>
            </div>
            <div className="p-4">
              <h3 className="text-sm font-bold text-foreground-900 mb-1">{card.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{card.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

/* ---- #about ---- */
export const AboutSection: FC = () => (
  <section id="about" className="py-14 md:py-20 bg-background-50">
    <div className="section-container">
      <div className="max-w-3xl mx-auto text-center">
        <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-3">
          关于我们
        </span>
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-6">
          关于91樱花
        </h2>
        <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
          <p>
            91樱花网成立于动漫爱好者社区，致力于为广大二次元用户提供最新、最全、最优质的动漫资源聚合服务。
            平台覆盖2026夏季新番、经典老番回顾、国漫精选、剧场版动画等全品类动漫内容，
            支持超清画质与多线路播放，满足不同用户的观看需求。
          </p>
          <p>
            我们采用行业领先的防封技术与智能域名调度系统，提供永久域名和备用入口，确保用户在任何网络环境下都能安全稳定地访问本站。
            91樱花以用户体验为核心，持续优化访问速度和资源更新频率，每日同步更新30+部动漫作品。
          </p>
          <p>
            91樱花官网网址始终以"高效、稳定、安全"为服务宗旨，打造国内领先的动漫资源入口平台。
            无论你是热血冒险迷、恋爱日常控，还是悬疑推理爱好者，在91樱花都能找到属于你的精彩。
          </p>
        </div>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-4 md:gap-8">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-primary-600 font-heading">5000+</div>
            <div className="text-xs text-foreground-400 mt-1">收录动漫作品</div>
          </div>
          <div className="w-px h-10 bg-background-200 hidden sm:block"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-accent-600 font-heading">30+</div>
            <div className="text-xs text-foreground-400 mt-1">每日更新部数</div>
          </div>
          <div className="w-px h-10 bg-background-200 hidden sm:block"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-primary-600 font-heading">99.9%</div>
            <div className="text-xs text-foreground-400 mt-1">服务可用率</div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

/* ---- #faq ---- */
const FAQS = [
  {
    q: '91樱花网站的永久域名是什么？如何防止域名被封？',
    a: '91樱花采用智能域名调度与分布式节点技术，提供多个永久域名和备用入口。建议收藏本站首页并关注站点公告，我们会定期更新最新防封地址，确保你始终能够安全稳定访问。',
  },
  {
    q: '91樱花网是否需要注册登录才能观看动漫？',
    a: '91樱花网站完全免费开放，无需注册或登录即可浏览和观看所有动漫资源。我们致力于提供无障碍的动漫观看体验，不受任何会员限制。',
  },
  {
    q: '91樱花的动漫资源更新频率是怎样的？',
    a: '我们每日同步更新30+部动漫作品，包括2026夏季新番、经典番剧、国漫精选和剧场版动画。新番通常在播出后2小时内完成更新上线，确保你能第一时间追到最新内容。',
  },
  {
    q: '91樱花支持哪些设备和画质？',
    a: '91樱花官网网址支持PC、平板和手机浏览器直接访问，无需下载任何APP。提供从标清到4K超清的多档画质选择，自动适配你的网络带宽和设备性能，保证流畅播放。',
  },
  {
    q: '如果在访问91樱花时遇到问题该怎么办？',
    a: '如果遇到访问异常，请先尝试刷新页面或切换备用域名。你也可以通过页面底部的联系方式或官方社区向我们反馈问题。我们会持续优化防封系统和服务稳定性，提升你的访问体验。',
  },
];

export const FaqSection: FC = () => (
  <section id="faq" className="py-14 md:py-20 bg-background-100">
    <div className="section-container">
      <div className="text-center mb-10">
        <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-3">
          常见问题
        </span>
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
          你关心的都在这里
        </h2>
        <p className="mt-2 text-sm text-foreground-500">关于91樱花的常见问题与解答</p>
      </div>
      <div className="max-w-2xl mx-auto space-y-3">
        {FAQS.map((faq, i) => (
          <div key={i} className="rounded-xl bg-background-50 border border-background-200/60 p-5 md:p-6">
            <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-3">
              <span className="text-primary-500 mr-2">Q{i + 1}.</span>
              {faq.q}
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed pl-6">
              {faq.a}
            </p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

/* ---- #index ---- */
const INDEX_ITEMS = [
  { title: '2026夏季新番一览', count: '86部', icon: 'ri-calendar-check-line' },
  { title: '热血冒险动漫大全', count: '312部', icon: 'ri-sword-line' },
  { title: '恋爱日常番合集', count: '198部', icon: 'ri-heart-line' },
  { title: '奇幻异世界转生', count: '247部', icon: 'ri-global-line' },
  { title: '悬疑推理番精选', count: '103部', icon: 'ri-search-eye-line' },
  { title: '国产动画专区', count: '156部', icon: 'ri-flag-2-line' },
  { title: '剧场版动画合集', count: '89部', icon: 'ri-film-line' },
];

export const IndexSection: FC = () => (
  <section id="index" className="py-14 md:py-20 bg-background-50">
    <div className="section-container">
      <div className="text-center mb-10">
        <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">
          专题索引
        </span>
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
          动漫分类导航
        </h2>
        <p className="mt-2 text-sm text-foreground-500">按主题快速找到你想看的动漫类型</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {INDEX_ITEMS.slice(0, 4).map((item, i) => (
          <a
            key={i}
            href="#ranking"
            className="flex items-center gap-4 p-5 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-300 transition-all duration-200 group"
          >
            <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-all duration-200 flex-shrink-0">
              <i className={`${item.icon} text-lg`}></i>
            </div>
            <div className="min-w-0">
              <h3 className="text-sm font-semibold text-foreground-900 truncate">{item.title}</h3>
              <p className="text-xs text-foreground-400 mt-0.5">{item.count}</p>
            </div>
          </a>
        ))}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-4">
        {INDEX_ITEMS.slice(4, 7).map((item, i) => (
          <a
            key={i}
            href="#ranking"
            className="flex items-center gap-4 p-5 rounded-xl bg-background-50 border border-background-200/60 hover:border-accent-300 transition-all duration-200 group"
          >
            <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-white transition-all duration-200 flex-shrink-0">
              <i className={`${item.icon} text-lg`}></i>
            </div>
            <div className="min-w-0">
              <h3 className="text-sm font-semibold text-foreground-900 truncate">{item.title}</h3>
              <p className="text-xs text-foreground-400 mt-0.5">{item.count}</p>
            </div>
          </a>
        ))}
      </div>
    </div>
  </section>
);

/* ---- #features ---- */
const FEATURES = [
  {
    icon: 'ri-shield-check-line',
    title: '永久域名防封',
    desc: '采用最新智能域名调度与分布式节点技术，提供稳定的永久域名和备用入口，确保你的访问不受干扰。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速更新同步',
    desc: '新番播出后2小时内完成更新上线，每日更新30+部动漫作品，让你第一时间追到最新内容。',
  },
  {
    icon: 'ri-hd-line',
    title: '4K超清画质',
    desc: '提供从标清到4K的多档画质选择，自动适配网络带宽和设备性能，保证流畅的高清播放体验。',
  },
];

export const FeaturesSection: FC = () => (
  <section id="features" className="py-14 md:py-20 bg-background-100">
    <div className="section-container">
      <div className="text-center mb-10">
        <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-3">
          平台优势
        </span>
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
          为什么选择91樱花
        </h2>
        <p className="mt-2 text-sm text-foreground-500">我们用心打造最好的动漫观看体验</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
        {FEATURES.map((f, i) => (
          <div key={i} className="text-center p-8 rounded-2xl bg-background-50 border border-background-200/60">
            <div className="w-14 h-14 mx-auto mb-5 flex items-center justify-center rounded-2xl bg-accent-100 text-accent-600">
              <i className={`${f.icon} text-2xl`}></i>
            </div>
            <h3 className="text-base font-bold text-foreground-900 mb-3">{f.title}</h3>
            <p className="text-sm text-foreground-500 leading-relaxed">{f.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

/* ---- #media ---- */
const MEDIA_ITEMS = [
  {
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20epic%20battle%20scene%20with%20a%20warrior%20wielding%20a%20glowing%20sword%20against%20a%20massive%20dragon%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20cherry%20blossom%20petals%20in%20the%20wind&width=800&height=500&seq=media-01-sakura&orientation=landscape',
    title: '剑风传说第3季 第8话精彩片段',
    plays: '23.5万',
    duration: '24:18',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20breathtaking%20space%20battle%20with%20starships%20and%20energy%20beams%2C%20nebula%20background%2C%20epic%20sci-fi%20aesthetic%2C%20warm%20color%20grading%2C%20cinematic%20wide%20shot&width=800&height=500&seq=media-02-sakura&orientation=landscape',
    title: '星辰变剧场版 官方预告片首曝',
    plays: '18.9万',
    duration: '02:35',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20emotional%20reunion%20scene%20between%20two%20characters%20under%20a%20blooming%20cherry%20tree%2C%20soft%20golden%20sunset%20light%2C%20tears%20of%20joy%2C%20romantic%20atmosphere&width=800&height=500&seq=media-03-sakura&orientation=landscape',
    title: '青春物语 最新话名场面剪辑',
    plays: '15.2万',
    duration: '18:42',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20mysterious%20detective%20scene%20in%20a%20rainy%20alley%2C%20neon%20lights%20reflecting%20on%20wet%20pavement%2C%20noir%20aesthetic%2C%20suspenseful%20atmosphere%2C%20cinematic%20lighting&width=800&height=500&seq=media-04-sakura&orientation=landscape',
    title: '暗夜侦探录 高能推理名场面',
    plays: '11.7万',
    duration: '32:10',
  },
];

export const MediaSection: FC = () => (
  <section id="media" className="py-14 md:py-20 bg-background-50">
    <div className="section-container">
      <div className="text-center mb-10">
        <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">
          视频专区
        </span>
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
          热门片段精选
        </h2>
        <p className="mt-2 text-sm text-foreground-500">精选热门动漫精彩片段与名场面</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {MEDIA_ITEMS.map((item, i) => (
          <div key={i} className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/60">
            <div className="relative aspect-video overflow-hidden">
              <img
                src={item.image}
                alt={item.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-black/20 group-hover:bg-black/35 transition-colors flex items-center justify-center">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white/90 text-primary-600 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                  <i className="ri-play-fill text-xl ml-0.5"></i>
                </div>
              </div>
              <span className="absolute bottom-2 right-2 px-1.5 py-0.5 rounded bg-black/60 text-white text-[10px] font-mono">
                {item.duration}
              </span>
            </div>
            <div className="p-4">
              <h3 className="text-sm font-semibold text-foreground-900 mb-1.5 line-clamp-1">{item.title}</h3>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-play-circle-line"></i>
                </div>
                <span>{item.plays} 次播放</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

/* ---- #comments ---- */
const COMMENTS = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20of%20a%20young%20man%20with%20warm%20smile%2C%20soft%20lighting%2C%20simple%20cream%20background%2C%20friendly%20expression&width=80&height=80&seq=avatar-01-sakura&orientation=squarish',
    name: '风之旅人',
    time: '2小时前',
    content: '91樱花真的是我用过最稳定的动漫网站了！永久域名很靠谱，更新速度也非常快，新番基本当天就能看到，画质选择也很多，强烈推荐给喜欢看动漫的朋友们。',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20of%20a%20young%20woman%20with%20gentle%20expression%2C%20soft%20pink%20background%2C%20warm%20lighting%2C%20cute%20anime%20art%20style&width=80&height=80&seq=avatar-02-sakura&orientation=squarish',
    name: '樱花下的约定',
    time: '5小时前',
    content: '从老域名追到新域名，91樱花网一直很用心在做。这次服务器升级之后访问速度快了好多，4K画质看《灵笼》第二季太爽了，画面细节满满，支持91樱花！',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20of%20an%20enthusiastic%20anime%20fan%20with%20sparkling%20eyes%2C%20simple%20warm%20background%2C%20cheerful%20expression&width=80&height=80&seq=avatar-03-sakura&orientation=squarish',
    name: '追番不停歇',
    time: '8小时前',
    content: '收藏了91樱花的永久域名后再也不怕找不到入口了，资源非常全，国漫和日漫都有覆盖。每天的更新快讯也很有用，可以第一时间了解番剧动态，真心不错。',
  },
];

export const CommentsSection: FC = () => (
  <section id="comments" className="py-14 md:py-20 bg-background-100">
    <div className="section-container">
      <div className="text-center mb-10">
        <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-3">
          用户评价
        </span>
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
          动漫爱好者说
        </h2>
        <p className="mt-2 text-sm text-foreground-500">来自真实用户的使用反馈</p>
      </div>
      <div className="max-w-3xl mx-auto space-y-4">
        {COMMENTS.map((c, i) => (
          <div key={i} className="rounded-2xl bg-background-50 border border-background-200/60 p-6">
            <div className="flex items-start gap-4">
              <img
                src={c.avatar}
                alt={c.name}
                className="w-10 h-10 rounded-full object-cover flex-shrink-0"
              />
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-sm font-semibold text-foreground-900">{c.name}</span>
                  <span className="text-xs text-foreground-400">{c.time}</span>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">{c.content}</p>
                <div className="flex items-center gap-3 mt-3">
                  <div className="flex items-center gap-1 text-xs text-foreground-400">
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-thumb-up-line"></i>
                    </div>
                    <span>{[156, 203, 178][i]}</span>
                  </div>
                  <div className="flex items-center gap-1 text-xs text-foreground-400">
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-chat-1-line"></i>
                    </div>
                    <span>回复</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);